import styled from 'styled-components'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  min-width: 540px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  min-width: auto;
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 10px;
  flex-direction: row;
  align-items: flex-end;
`

/*
  O último bloco de cada aba fica sem margem embaixo. Com o caixa fechado não há botões depois das
  listas, e a margem de 15px da última lista (ou do aviso de caixa fechado) sobrava no fim do
  modal. Isso era compensado com marginBottom: -12 no Form, mas margem negativa dentro de um
  contêiner com scroll empurra a borda do conteúdo para fora, e a barra de rolagem aparecia mesmo
  em comanda que cabia na tela.
*/
export const Info = styled(Container)`
  padding: 0px;

  & > :last-child {
    margin-bottom: 0px;
  }
`

export const FormField = styled(Container)`
  min-width: auto;
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -6px #252525;
  padding-top: 5px;
  margin-bottom: 20px;
  border-radius: 15px;
  justify-content: center;
  align-items: flex-start;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  align-self: center;
`;

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const Label = styled(InfoText)`
  margin-bottom: 5px;
  color: #000000;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`
